export const ABOUT_YOUTUBE_URL = "https://youtu.be/ENBNsrCd4Vg";
export const ABOUT_EMAIL_ADDRESS = "press@airhelp.com";
